import { useState } from 'react';
import { Form, Select } from 'antd';
import debounce from 'lodash.debounce';
import { useGetManyCargos } from 'api/cargos/use-get-many-cargos';
import type { ICargoFormSelectProps } from './types';

export const CargoFormSelect = (props: ICargoFormSelectProps) => {
  const { name, handleChange, placeholder, label, rules, disable = false } = props;

  const [search, setSearch] = useState('');
  const { data: cargos, isLoading } = useGetManyCargos({ limit: 10, search: search });

  const handleClientSearch = debounce((value: string) => {
    setSearch(value);
  }, 400);

  const options = cargos?.data.map((cargo) => {
    return {
      value: cargo.id,
      label: cargo.compositeId,
    };
  });

  return (
    <Form.Item label={label} name={name} rules={rules}>
      <Select
        placeholder={placeholder}
        loading={isLoading}
        filterOption={false}
        notFoundContent={null}
        disabled={disable}
        options={options}
        showSearch
        labelInValue
        onSearch={handleClientSearch}
        onChange={handleChange}
      />
    </Form.Item>
  );
};
